/* globals cpac, $j */

if (typeof cpac !== 'undefined') {
  cpac.audit = {
    on_page: 100,
  
    info_search: function (table_class,input_id) {
        return this.search(table_class, input_id, 'paging_tbody', 'paging_top', 'page1', 'more_search_result', 'audit_table_head', 'search_result');
    },
    trans_search: function (table_class,input_id) {
        return this.search(table_class, input_id, 'tpaging_tbody', 'trans_paging_top', 'tpage1', 't_more_search_result', 't_audit_table_head', 't_search_result');
    },
    search: function (table_class,input_id, page_body, page_top, page1_id, more_results, table_head, result_class) {
        var input = $j('#'+input_id);
        var value = input.attr('value');
        value = value.toLowerCase();
  
        $j('.'+page_body).removeClass('hidden');
        $j('.'+page_body).show();
        $j('#'+page_top).hide();
  
        if (value) {
            let tr = $j('.'+table_class).children().children();
            $j.each(tr, function(key, val) {
                Element.show(val);
            });
            var results = 0;
            var that = this;
            $j.each(tr, function(key, val) {
                if (val.innerHTML.toLowerCase().indexOf(value) >=0) {
                    Element.addClassName(val, result_class);
                    results++;
                    if (results > that.on_page) {
                    Element.hide(val);
                    }
                } else {
                    Element.removeClassName(val, result_class);
                    Element.hide(val);
                }
            });
            if (results > this.on_page) {
                $j('#'+more_results).removeClass('hidden');
                $j('#'+more_results).show();
            }
        } else {
            let tr = $j('.'+table_class).children().children();
            $j.each(tr, function(key, val) {
                Element.show(val);
            });
            $j('#'+page_top).show();
            $j('.'+page_body).hide();
            $j('#'+page1_id).show();
            $j('#'+more_results).hide();
        }
        $j('#'+table_head).show();
    }
  }
}